/** Matches backend SEARCH_RADIUS_MILES; used for UI copy only. */
export const SEARCH_RADIUS_MILES = 100;

/**
 * Preferred nearby band for map framing and honesty messaging.
 * Results outside this band can still appear from SEARCH_RADIUS_MILES.
 */
export const NEARBY_DISPLAY_RADIUS_MILES = 20;

/** Shared options for "use my current location" geolocation requests. */
export const GEOLOCATION_POSITION_OPTIONS: PositionOptions = {
  enableHighAccuracy: false,
  timeout: 15000,
  maximumAge: 60_000,
};
